export enum OrderActionTypes {
    API_RESPONSE_SUCCESS = '@@orders/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@orders/API_RESPONSE_ERROR',

    GET_ORDERS = '@@orders/GET_ORDERS',
    GET_ORDER_DETAILS = '@@orders/GET_ORDER_DETAILS',
}
